import { RESOURCE } from "../../../../routes/const";

export default () => {
  const rules = [];
  rules.push({
    action: "manage",
    subject: RESOURCE.creative.nested.projectSchedule,
  });

  rules.push({
    action: "manage",
    subject: RESOURCE.creative.nested.projects,
  });
  return rules;
};
